export const searchProducts = async function (context, query) {
    if (!query || query.length < 2) {
        context.commit('SET_SEARCH_RESULTS', [])
        context.commit('SET_SEARCHING', false)
        return
    }
    context.commit('SET_SEARCHING', true)
    try {
        const response = await window.axios.get('/pos/products/search?q=' + encodeURIComponent(query))
        context.commit('SET_SEARCH_RESULTS', response.data)
    } catch (e) {
        context.commit('SET_SEARCH_RESULTS', [])
    } finally {
        context.commit('SET_SEARCHING', false)
    }
}

export const loadCategories = async function (context) {
    if (Object.keys(context.state.categories).length > 0) return
    try {
        const response = await window.axios.get('/pos/categories/all')
        context.commit('ADD_CATEGORIES', response.data)
    } catch (e) {
        // 422 si pas de session active — ignoré silencieusement
    }
}

// Stock modifié (entrée, transfert, vente POS / e-commerce) : rechargement silencieux
// des catégories, de la catégorie ouverte et des lots, sans indicateur de chargement.
export const refreshFromStock = async function (context) {
    try {
        const opened = context.state.openedCategorie
        const response = await window.axios.get('/pos/categories/all')
        const categories = {}
        response.data.forEach(cat => { categories[cat.id] = { ...cat, products: [] } })

        const stillOpened = opened && categories[opened] ? opened : null
        let openedProducts = null
        if (stillOpened) {
            openedProducts = (await window.axios.get('/pos/categories/' + stillOpened + '/products')).data
        }
        context.commit('REPLACE_CATEGORIES', { categories, opened: stillOpened, openedProducts })

        if (context.state.bundlesLoaded) {
            const bundles = await window.axios.get('/pos/bundles')
            context.commit('SET_BUNDLES', bundles.data)
        }
    } catch (e) {
        // session fermée ou erreur réseau — l'affichage actuel est conservé
    }
}

export const loadBundles = async function (context) {
    if (context.state.bundlesLoaded) return
    context.commit('SET_LOADING_BUNDLES', true)
    try {
        const response = await window.axios.get('/pos/bundles')
        context.commit('SET_BUNDLES', response.data)
    } catch (e) {
        context.commit('SET_BUNDLES', [])
    } finally {
        context.commit('SET_LOADING_BUNDLES', false)
    }
}

// Préchargement en arrière-plan (recherche scanner) : charge les produits d'une
// catégorie SANS la sélectionner — loadProducts, lui, la marque comme ouverte,
// ce qui faisait sélectionner la dernière catégorie préchargée au démarrage.
export const preloadProducts = async function (context, idCategorie) {
    const already = context.state.categories[idCategorie]
    if (!idCategorie || (already && already.loaded)) return
    try {
        const response = await window.axios.get('/pos/categories/' + idCategorie + '/products')
        context.commit('ADD_PRODUCTS', { id: idCategorie, products: response.data })
    } catch (e) {
        // préchargement facultatif
    }
}

export const loadProducts = async function (context, idCategorie) {
    if (!idCategorie) {
        context.commit('SET_OPENED_CATEGORIES', null)
        return
    }
    const already = context.state.categories[idCategorie]
    if (already && already.loaded) {
        context.commit('SET_OPENED_CATEGORIES', idCategorie)
        return
    }
    const isFirstLoad = !context.state.categoryLoaded
    if (isFirstLoad) context.commit('SET_LOADING', true)
    context.commit('SET_LOADING_PRODUCTS', true)
    context.commit('SET_OPENED_CATEGORIES', idCategorie)
    try {
        const response = await window.axios.get('/pos/categories/' + idCategorie + '/products')
        context.commit('ADD_PRODUCTS', { id: idCategorie, products: response.data })
        if (isFirstLoad) context.commit('SET_CATEGORY_LOADED')
    } finally {
        if (isFirstLoad) context.commit('SET_LOADING', false)
        context.commit('SET_LOADING_PRODUCTS', false)
    }
}
